if (!customElements.get('smooche-urgency')) {
  customElements.define('smooche-urgency', class extends HTMLElement {
    connectedCallback() {
      var root = this;

      function clamp(n, min, max) {
        return Math.min(max, Math.max(min, n));
      }

      function randInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function readStore(key) {
        try {
          var raw = sessionStorage.getItem(key);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }

      function writeStore(key, value) {
        try {
          sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {}
      }

      // —— Sold % ——
      var storageKey = root.getAttribute('data-cs-storage-key') || 'cs-urgency';
      var soldRandomize = root.getAttribute('data-cs-sold-randomize') !== 'false';
      var soldMin = parseInt(root.getAttribute('data-cs-sold-min'), 10) || 60;
      var soldMax = parseInt(root.getAttribute('data-cs-sold-max'), 10) || 90;
      var soldFixed = parseInt(root.getAttribute('data-cs-sold-fixed'), 10) || 89;
      var soldSuffix = root.getAttribute('data-cs-sold-suffix') || '';

      if (soldMin > soldMax) {
        var tmpSold = soldMin;
        soldMin = soldMax;
        soldMax = tmpSold;
      }
      soldMin = clamp(soldMin, 1, 99);
      soldMax = clamp(soldMax, soldMin, 99);

      var signature = [soldRandomize, soldMin, soldMax, soldFixed].join('|');
      var stored = readStore(storageKey) || {};
      if (stored.signature !== signature) stored = {};

      var soldPct;
      if (!soldRandomize) {
        soldPct = clamp(soldFixed, 1, 99);
      } else if (typeof stored.soldPct === 'number' && stored.soldPct >= soldMin && stored.soldPct <= soldMax) {
        // Keep the same value for the whole browser session
        soldPct = stored.soldPct;
      } else {
        soldPct = randInt(soldMin, soldMax);
      }
      writeStore(storageKey, { soldPct: soldPct, signature: signature });

      root.style.setProperty('--cs-sold-pct', soldPct + '%');
      var soldLabel = root.querySelector('[data-cs-sold-label]');
      if (soldLabel) soldLabel.textContent = soldPct + soldSuffix;

      // —— Countdown to the end date set in the editor ——
      var display = root.querySelector('[data-cs-countdown]');
      var timerRow = root.querySelector('[data-cs-timer]');
      var expiry = root.getAttribute('data-cs-timer-expiry') || 'hide';
      var weekly = root.getAttribute('data-cs-timer-mode') !== 'date';
      // Fixed mode: Unix seconds, resolved in Liquid in the store time zone
      var endsAt = (parseInt(root.getAttribute('data-cs-timer-end'), 10) || 0) * 1000;

      // Weekly mode (same as smooche.com): the coming Monday 00:00 in the
      // visitor's time zone, rolling over to the next week when it is reached.
      function nextMonday() {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + ((8 - now.getDay()) % 7 || 7), 0, 0, 0, 0).getTime();
      }

      if (!display) return;
      if (weekly) endsAt = nextMonday();
      if (!endsAt) {
        // End date could not be parsed: don't show a broken timer
        if (timerRow) timerRow.hidden = true;
        return;
      }

      var tick = function () {
        if (weekly) endsAt = nextMonday();
        var ms = Math.max(0, endsAt - Date.now());
        if (ms === 0 && !weekly) {
          if (expiry === 'hide' && timerRow) timerRow.hidden = true;
          clearInterval(root.timer);
        }
        var totalSec = Math.floor(ms / 1000);
        var d = Math.floor(totalSec / 86400);
        var h = Math.floor((totalSec % 86400) / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        display.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      };
      tick();
      if (weekly || endsAt > Date.now()) this.timer = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  });
}
